const classical = {
    classical: {
        icon: null,
        text: 'Klasikal',
        route: 'admin.participant.classical',
        role: {
            classical: [ 'admin' ],
            paper: [ 'admin' ],
            performance: [ 'admin' ],
            project: [ 'admin'],
            evaluation: [ 'admin' ]
        }
    },
}

export default classical
